import { useLocation } from 'react-router-dom';
import { routerQuoteDetailData } from 'src/const/enum';

export type QuoteSection = (typeof routerQuoteDetailData)[number];

const useQuoteSectionNav = () => {
    const { pathname, search } = useLocation();
    const queryParams = new URLSearchParams(search);
    const quoteId = queryParams.get('id') || '';
    const multipleQuotes = queryParams.get('multipleQuotes');
    const basePath = pathname.includes('quoteDetail')
        ? 'quoteDetail'
        : 'multipleQuotes';

    const buildPath = (path: string) =>
        `/${basePath}/${path}?id=${quoteId}${
            multipleQuotes ? `&multipleQuotes=${multipleQuotes}` : ''
        }`;

    const isActive = (path: string) => pathname.includes(path);

    const currentIndex = routerQuoteDetailData.findIndex((section) =>
        isActive(section.path),
    );

    const prev: QuoteSection | undefined =
        currentIndex > 0 ? routerQuoteDetailData[currentIndex - 1] : undefined;
    const next: QuoteSection | undefined =
        currentIndex >= 0 ? routerQuoteDetailData[currentIndex + 1] : undefined;

    return {
        sections: routerQuoteDetailData,
        currentIndex,
        prev,
        next,
        buildPath,
        isActive,
    };
};

export default useQuoteSectionNav;
